// Specialized AI Courses - Advanced Topics
export { nvidiaAIPlatformCourse } from './nvidia-ai-platform';
export { googleGeminiCourse } from './google-gemini-development';
export { githubAIDevelopmentCourse } from './github-ai-development';
export { aiPlatformIntegrationCourse } from './ai-platform-integration';

import { nvidiaAIPlatformCourse } from './nvidia-ai-platform';
import { googleGeminiCourse } from './google-gemini-development';
import { githubAIDevelopmentCourse } from './github-ai-development';
import { aiPlatformIntegrationCourse } from './ai-platform-integration';

export const SPECIALIZED_AI_COURSES = [
  nvidiaAIPlatformCourse,
  googleGeminiCourse,
  githubAIDevelopmentCourse,
  aiPlatformIntegrationCourse,
];
